import { Theme } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { useVariantIndexSelector } from '../../../state/SplitTests/selectors/useVariantIndexSelector';
import { PropsWithChildren } from 'react';

type BadgeProps = {
  variantPosition: number;
  isCircle: boolean;
};
interface WorkflowBadgeProps {
  variantId: string;
  isCircle?: boolean;
}

function getColor(props: BadgeProps, theme: Theme) {
  switch (props.variantPosition) {
    case 1:
      return theme.designToken.primary700;
    case 2:
      return theme.designToken.secondary700;
    default:
      return theme.designToken.primary700;
  }
}

function getBackground(props: BadgeProps, theme: Theme) {
  switch (props.variantPosition) {
    case 1:
      return theme.designToken.primary50;
    case 2:
      return theme.designToken.secondary50;
    default:
      return theme.designToken.primary50;
  }
}

const Badge = styled.div<BadgeProps>`
  font: ${props => (props.isCircle ? props.theme.designToken.headingH3 : props.theme.designToken.body2Semibold)};
  border-radius: ${props => (props.isCircle ? props.theme.designToken.borderRadius4 : '4px')};
  display: flex;
  padding: ${({ theme }) => theme.designToken.spacing1} ${({ theme }) => theme.designToken.spacing2};
  justify-content: center;
  align-items: center;
  background: ${props => getBackground(props, props.theme)};
  color: ${props => getColor(props, props.theme)};
  width: ${props => (props.isCircle ? '40px' : 'auto')};
  height: ${props => (props.isCircle ? '40px' : 'auto')};
`;

export const WorkflowBadge = ({ variantId, isCircle, children }: PropsWithChildren<WorkflowBadgeProps>) => {
  const variantPosition = useVariantIndexSelector(variantId);
  return (
    <Badge variantPosition={variantPosition + 1} isCircle={isCircle}>
      {children}
    </Badge>
  );
};
